import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../components/layout/Layout";
import Pagination from "./../../components/Pagination";
import { Link, useNavigate } from "react-router-dom";
// import ViewFleet from "./ViewFleet";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import axios from "axios";
import { toast } from "react-toastify";
import ConfirmationModal from "../../components/modals/ConfirmationModal";

const InvoiceList = ({ pageLoading, fleetListData, not_found }) => {
  const navigate = useNavigate();
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const getAllOrders = async () => {
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      await axios.get(`${APIURL}/api/v1/customOrder`, config);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    getAllOrders();
  }, []);

  const fleetDel = async (id) => {
    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    if (window.confirm("Do you want to delete the invoice?")) {
      fetch(`${APIURL}/api/v1/customOrder/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result?.status === "success") {
            toast.success("Invoice Deleted Successfully!");
            getAllOrders();
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  const handleDuplicate = (item) => {
    setSelectedItem(item);
    setShowDuplicateModal(true);
  };

  const executeDuplicate = async () => {
    navigate("/invoice", { state: selectedItem });
  };

  const getBadge = (status) => {
    switch (status) {
      case "available":
        return "success";
      case "busy":
        return "warning";
      default:
        return "primary";
    }
  };
  const headers = [
    { label: "_id", key: "id" },
    { label: "Fleet Name", key: "name" },
    { label: "Model", key: "model" },
    { label: "Fuel Type", key: "fuel" },
    { label: "Status", key: "status" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];
  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id,
  //         name: item?.name,
  //         model: item?.vehicle_model,
  //         fuel: item?.fuel_type,
  //         status: item?.status,
  //         created: item?.createdAt,
  //         updated: item?.updatedAt,
  //       };
  //     })
  //   : "";
  // pdf code start - Download from backend
  const downloadPDF = async () => {
    try {
      const token = localStorage.getItem("token");
      const params = new URLSearchParams();

      // Add filters to params
      if (keyword) params.append("keyword", keyword);
      if (filterDate.startDate)
        params.append("startDate", filterDate.startDate);
      if (filterDate.endDate) params.append("endDate", filterDate.endDate);

      // Download PDF from backend
      const url = `${APIURL}/api/v1/customOrder/download/pdf?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      // Convert response to blob and download
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "roadside_invoices.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast.error("Failed to download PDF");
    }
  };
  // pdf code end

  /**csv download file code start here - Download from backend **/
  const csvDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const params = new URLSearchParams();

      // Add filters to params
      if (keyword) params.append("keyword", keyword);
      if (filterDate.startDate)
        params.append("startDate", filterDate.startDate);
      if (filterDate.endDate) params.append("endDate", filterDate.endDate);

      // Download CSV from backend
      const url = `${APIURL}/api/v1/customOrder/download/csv?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download CSV");
      }

      // Convert response to blob and download
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "roadside_invoices.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("CSV downloaded successfully!");
    } catch (error) {
      console.error("Error downloading CSV:", error);
      toast.error("Failed to download CSV");
    }
  };

  // filter data
  const [keyword, setKeyword] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // filter date
  const [filterDate, setFilterDate] = useState({ startDate: "", endDate: "" });
  const handleFilterDate = (e) =>
    setFilterDate((prevDate) => ({
      ...prevDate,
      [e.target.name]: e.target.value,
    }));

  const handleResetFilter = () => {
    setFilterDate({ startDate: "", endDate: "" });
    setSearchQuery("");
    setKeyword("");
    setCurrentPage(1);
  };

  // Apply search function
  const applySearch = () => {
    setKeyword(searchQuery);
  };

  // Fetch filtered data from backend
  const fetchFilteredOrders = useCallback(async () => {
    const token = localStorage.getItem("token");
    const params = new URLSearchParams();

    // Add filters to params
    if (keyword) params.append("keyword", keyword);
    if (filterDate.startDate) params.append("startDate", filterDate.startDate);
    if (filterDate.endDate) params.append("endDate", filterDate.endDate);
    params.append("page", currentPage);
    params.append("limit", 10); // 10 items per page

    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.get(
        `${APIURL}/api/v1/customOrder?${params.toString()}`,
        config,
      );
      setFilterData(res?.data?.data?.customOrder || []);
      setTotalCount(res?.data?.totalCount || 0);
      setTotalPages(res?.data?.totalPages || 1);
      setCurrentPage(res?.data?.currentPage || 1);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch orders");
    }
  }, [keyword, filterDate.startDate, filterDate.endDate, currentPage]);

  // Reset page to 1 when filters change, then fetch data
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      fetchFilteredOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword, filterDate.startDate, filterDate.endDate]);

  // Fetch data when page changes (but not on initial mount when filters change)
  useEffect(() => {
    if (currentPage !== 1) {
      fetchFilteredOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />

      <Layout title="List of Invoices" page="invoicelist">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  {/* Delete Selected button removed - not used in invoice list */}
                  {/* <label>
                    Show
                    <select
                      name="kt_datatable_example_5_length"
                      aria-controls="kt_datatable_example_5"
                      className="form-select form-select-sm form-select-solid"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label> */}
                </div>
              </div>
              <div className="col-sm-12 d-flex align-items-center justify-content-between flex-column flex-xl-row">
                <div className="col-md-12 col-lg-6 d-flex align-items-center">
                  <div className="">
                    <input
                      className="form-control"
                      name="startDate"
                      type="date"
                      onChange={handleFilterDate}
                      value={filterDate.startDate}
                    />
                  </div>
                  <span className="mx-4 fw-bolder">To</span>
                  <div>
                    <input
                      className="form-control"
                      name="endDate"
                      min={filterDate?.startDate || ""}
                      type="date"
                      onChange={handleFilterDate}
                      value={filterDate.endDate}
                    />
                  </div>
                  {(filterDate.startDate || filterDate.endDate) ? (
                    <button
                      type="button"
                      className="btn btn-light-danger ms-2"
                      onClick={handleResetFilter}
                    >
                      Reset
                    </button>
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-md-12 col-lg-6 d-flex align-items-center justify-content-end">
                  <div
                    id="kt_datatable_example_5_filter"
                    className="dataTables_filter"
                  >
                    <label className="w-100">
                      <span className="me-2">Search:</span>

                      <div className="position-relative w-100">
                        <input
                          type="search"
                          value={searchQuery}
                          onChange={(e) => {
                            setSearchQuery(e.target.value);
                            // Clear search results when input is cleared
                            if (e.target.value === "") {
                              setKeyword("");
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              applySearch();
                            }
                          }}
                          className="form-control form-control-sm form-control-solid pe-10"
                          placeholder="Search..."
                          aria-controls="kt_datatable_example_5"
                        />

                        {/* Button INSIDE input */}
                        {searchQuery !== "" && (
                          <button
                            type="button"
                            onClick={applySearch}
                            className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-1"
                            aria-label="Search"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                            </svg>
                          </button>
                        )}
                      </div>
                    </label>
                  </div>
                  <div className="ms-3 p-2">
                    <a
                      className="btn pgf btn-secondary dropdown-toggle"
                      href="#"
                      // role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      // className="csvlink"
                      style={{ background: "none" }}
                    >
                      Download File
                    </a>

                    <ul className="dropdown-menu">
                      <li>
                        <a
                          className="dropdown-item"
                          style={{ color: "#000" }}
                          onClick={csvDownload}
                        >
                          {/* <CSVLink
                            style={{ color: "#000" }}
                            data={[]}
                            headers={headers}
                          > */}
                          Download as CSV
                          {/* </CSVLink> */}
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" onClick={downloadPDF}>
                          Download as PDF
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          <th style={{ width: "139.781px" }}>Invoice No</th>
                          <th style={{ width: "127.297px" }}>Full Name</th>
                          <th style={{ width: "117.438px" }}>Email</th>
                          <th style={{ width: "117.438px" }}>Date</th>
                          <th style={{ width: "75.438px" }}>Total</th>
                          <th style={{ width: "117.438px" }}>Technician</th>
                          <th style={{ width: "75.438px" }}>Tip</th>
                          <th style={{ width: "227.344px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filterData?.length ? (
                          filterData?.map((item, index) => {
                            return (
                              <tr key={index} className="pro-list-info">
                                <td>{item.orderNo}</td>
                                <td>{item.name}</td>
                                <td>{item.email}</td>
                                <td>{item.date.slice(0, 10)}</td>
                                <td>{parseFloat(item.total)?.toFixed(2)}</td>
                                <td>{item.technician}</td>
                                <td>
                                  {parseFloat(item.tipAmount || 0)?.toFixed(2)}
                                </td>
                                <td>
                                  <Link
                                    to={`/view-invoice/${item.id}`}
                                    className="btn btn-primary"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </Link>
                                  <Link
                                    to={`/edit-invoice/${item._id}`}
                                    className="btn btn-info action-hover"
                                  >
                                    {" "}
                                    {/* Updated route */}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                      />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="/invoice-list"
                                    onClick={() => fleetDel(item.id)}
                                    className="btn btn-bg-dark action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                  </Link>
                                  <button
                                    onClick={() => handleDuplicate(item)}
                                    className="btn btn-warning action-hover ms-2"
                                    title="Duplicate"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-files"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                                    </svg>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : !not_found ? (
                          <div className="spinner-outer p-5">
                            <p>Data not found</p>
                          </div>
                        ) : (
                          <div className="spinner-outer p-5">
                            <p>Data not found</p>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    pageSize={10}
                    items={filterData}
                    totalItems={totalCount}
                    serverSide={true}
                    initialPage={currentPage}
                    onChangePage={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <ConfirmationModal
        isOpen={showDuplicateModal}
        onClose={() => setShowDuplicateModal(false)}
        onConfirm={executeDuplicate}
        title="Duplicate Invoice"
        message="This will open the duplication form. You can review and edit before saving."
        confirmText="Yes, Duplicate"
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.fleet?.loading,
  fleetListData: state?.fleet?.list,
  not_found: state?.fleet?.not_found,
});

export default connect(mapStateToProps)(InvoiceList);
